module.exports = __webpack_public_path__ + "static/media/a-112-02-mobile.8c982b2d.webp";